import React, { Dispatch, ReactNode, createContext, useReducer } from 'react';

import * as types from './types';
import { LiveClassState } from '../../types';

type LiveClassAction = { type: string; payload: LiveClassState };

const initialState: LiveClassState = {
  showClassStartPopup: { showPopup: false, classInfo: null },
  currentChapterDetails: null,
  selectedPillChapterId: 0,
  selectedPillCellIdx: -1,
  isGettingSessions: false,
  sessionsList: null,
  teacherDetails: null,
  isGettingTeacherDetails: false,
  demoClassActiveSessionId: 0,
};

const liveClassReducer = (
  state: LiveClassState,
  action: LiveClassAction,
): LiveClassState => {
  switch (action.type) {
    case types.SHOW_CLASS_START_POP_UP:
      return {
        ...state,
        showClassStartPopup: action.payload.showClassStartPopup,
      };
    case types.SET_CURRENT_CHAPER_DETAILS:
      return {
        ...state,
        currentChapterDetails: action.payload.currentChapterDetails,
      };
    case types.SET_SELECTED_CHAPTER_PILL_INFO:
      return {
        ...state,
        selectedPillChapterId: action.payload.selectedPillChapterId,
        selectedPillCellIdx: action.payload.selectedPillCellIdx,
      };
    case types.SET_GETTING_SESSION_LIST:
      return {
        ...state,
        isGettingSessions: action.payload.isGettingSessions,
      };
    case types.SET_SESSION_LIST:
      return {
        ...state,
        sessionsList: action.payload.sessionsList,
      };
    case types.GET_TEACHER_DETAILS:
      return {
        ...state,
        teacherDetails: action.payload.teacherDetails,
      };
    case types.GETTING_TEACHER_DETAILS:
      return {
        ...state,
        isGettingTeacherDetails: action.payload.isGettingTeacherDetails,
      };
    case types.ACTIVE_DEMO_CLASS_SESSION_ID:
      return {
        ...state,
        demoClassActiveSessionId: action.payload.demoClassActiveSessionId,
      };

    default:
      return initialState;
  }
};

type LiveClassContextType = [LiveClassState | null, Dispatch<LiveClassAction>];
export const LiveClassContext = createContext<LiveClassContextType>([
  initialState,
  () => initialState,
]);

const LiveClassProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
  const [liveClassState, liveClassDispatch] = useReducer(
    liveClassReducer,
    initialState,
  );

  return (
    <LiveClassContext.Provider value={[liveClassState, liveClassDispatch]}>
      {children}
    </LiveClassContext.Provider>
  );
};

export default LiveClassProvider;
